import { useState } from "react";
import { motion } from "framer-motion";

const CategoryPopup = ({ onClose, onSave, initialSubcategories }) => {
  // Estado principal: array de objetos { number?, group_name? }
  const [subcategories, setSubcategories] = useState(
    initialSubcategories || [],
  );

  // Maneja cambio de número
  const handleNumberChange = (index, value) => {
    const updated = [...subcategories];
    updated[index].number = value ? parseInt(value) : null;
    setSubcategories(updated);
  };

  // Maneja cambio de nombre
  const handleNameChange = (index, value) => {
    const updated = [...subcategories];
    updated[index].group_name = value || null;
    setSubcategories(updated);
  };

  // Agregar nueva subcategoría vacía
  const handleAddSubcategory = () => {
    setSubcategories([...subcategories, { number: null, group_name: "" }]);
  };

  // Eliminar subcategoría
  const handleRemoveSubcategory = (index) => {
    setSubcategories(subcategories.filter((_, i) => i !== index));
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -50, opacity: 0 }}
        transition={{ duration: 0.25 }}
        className="bg-white rounded-xl shadow-xl w-[32rem] max-h-[90vh] overflow-y-auto p-6"
      >
        <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
          Configurar Subcategorías
        </h2>

        <div className="space-y-4">
          {subcategories.map((sub, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 p-3 border rounded-lg hover:shadow-md transition"
            >
              {/* Número de subcategoría */}
              <input
                type="number"
                placeholder="Número (opcional)"
                value={sub.number || ""}
                onChange={(e) => handleNumberChange(index, e.target.value)}
                className="w-20 border rounded p-2 text-center"
                min={0}
              />

              {/* Nombre del grupo */}
              <input
                type="text"
                placeholder="Nombre del grupo (opcional)"
                value={sub.group_name || ""}
                onChange={(e) => handleNameChange(index, e.target.value)}
                className="flex-1 border rounded p-2"
              />

              {/* Botón eliminar */}
              <button
                onClick={() => handleRemoveSubcategory(index)}
                className="text-red-500 hover:text-red-700 font-bold text-xl"
                title="Eliminar subcategoría"
              >
                ×
              </button>
            </div>
          ))}
        </div>

        {/* Botón añadir nueva subcategoría */}
        <div className="mt-4 flex justify-center">
          <button
            type="button"
            onClick={handleAddSubcategory}
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-semibold transition"
          >
            + Añadir Subcategoría
          </button>
        </div>

        {/* Botones de acción */}
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg font-semibold transition"
          >
            Cancelar
          </button>
          <button
            onClick={() => {
              const invalid = subcategories.some(
                (sub) => !sub.number && !sub.group_name?.trim(),
              );
              if (invalid) {
                alert(
                  "Completa al menos el número o el nombre del grupo en cada subcategoría.",
                );
                return;
              }
              onSave(subcategories);
            }}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold transition"
          >
            Guardar
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default CategoryPopup;
